// 応答本文の Markdown リンク `[氏名](user:コード)` から、チップ表示に使うユーザーコードを取り出す。
//
// ユーザーコードは WBS アイテムのコードと違い 8 桁のランダム英数字ではない。テナントが人手で
// 決める識別子で（users.code は varchar(256)、ユーザー一覧の画面から編集できる）、実データも
// `HR0000001` のような社員番号の体裁になっている。そのため wbsLinkHref のような文字種・桁数の
// 厳密一致は使えない（テナントごとの採番規則を弾いてしまい、実在のユーザーがチップにならない）。
//
// 一方でこの値はユーザー取得 API のクエリパラメータ（encodeURIComponent される）に載るだけで、
// 内部パスには埋め込まない（このチップは遷移先を持たない）。パス・トラバーサルのような
// 埋め込み先固有のリスクが無いため、ここでは「明らかにコードではないもの」だけを弾く。
// 弾いた場合は null を返し、呼び出し側は通常のリンク（またはプレーンテキスト）として
// 描画する（優雅な劣化）。
const USER_LINK_SCHEME = 'user:'
// users.code の桁数に合わせる。これより長い値は実在しえないため、無駄な取得を投げない。
const USER_CODE_MAX_LENGTH = 256
// 空白（改行・タブを含む）はコードには現れず、リンクの綴り崩れや本文の混入を示す。
const WHITESPACE_PATTERN = /\s/

export const parseUserLinkHref = (href: string): string | null => {
  if (!href.startsWith(USER_LINK_SCHEME)) {
    return null
  }
  const code = href.slice(USER_LINK_SCHEME.length)
  if (!code || code.length > USER_CODE_MAX_LENGTH) {
    return null
  }
  return WHITESPACE_PATTERN.test(code) ? null : code
}
